export default{
    data(){
        return{
            languageMapper:{},
            languageOrientation : 'LTR',
        }
    },
    watch:{
        languageOrientation() {
            this.applyDirection();
            this.updateToastDirection();
        },
    },    
    methods: {
        isRTL() {
            return this.$i18n.orientation === "RTL";
        },

        applyDirection() {
            const lang = this.$i18n.locale;
            const orientation = this.$i18n.orientation;
            // const rtl = ['ar'].includes(lang);
            // const rtl = this.isRTL(lang);
            // alert(this.languageOrientation)
            document.documentElement.setAttribute('lang', lang);
            document.documentElement.setAttribute('dir', orientation);
        },

        updateToastDirection(){
            const rtl = this.isRTL();

            this.$toast.updateDefaults({
                position: rtl ? "bottom-left" : "bottom-right",
                rtl
            });
        },

        initializeLanguage() {
            let userInfo = null;

            try {
                userInfo = JSON.parse(
                    localStorage.getItem("userInfo")
                );
            } catch (error) {
                console.error(
                    "Unable to read userInfo:",
                    error
                );
            }

            if (userInfo && userInfo.user_language) {
                this.getUserPreferedLanguage();
            }
            else {
                return this.setDefaultLanguage();
            }    
        },

        setDefaultLanguage() {
            this.$set(this.$i18n, "locale", "en");
            this.$set(this.$i18n, "locale_name", "English");
            this.$set(this.$i18n, "orientation", "LTR");

            this.$i18n.setLocaleMessage("en", {});

            this.applyDirection();
            this.updateToastDirection();
        },

        applyUserLanguage(userInfo) {
            if (userInfo && userInfo.user_language) {
                return this.getUserPreferedLanguage();
            }

            this.setDefaultLanguage();
        },

        getUserPreferedLanguage() {
            return this.fetchUserPrefferedLanguage().then((data) => {
                if (!data || !data.mapper) {
                    return this.setDefaultLanguage();
                }

                const languageCode = data.code || "en";
                const languageName = data.name || "English";
                this.languageOrientation = data.orientation || "LTR";
                this.languageMapper = data.mapper || {};

                this.$set(this.$i18n, "locale", languageCode);
                this.$set(this.$i18n, "locale_name", languageName);
                this.$set(this.$i18n, "orientation", this.languageOrientation);

                this.$i18n.setLocaleMessage(
                    languageCode,
                    this.languageMapper
                );

                this.applyDirection();
                this.updateToastDirection();

                return data;
            })
            .catch((error) => {
                console.error(
                    "Failed to load preferred language:",
                    error
                );

                return this.setDefaultLanguage();
            });
        },
    }
}
   
